module.exports = __webpack_public_path__ + "img/rs_multimintL.4a36a9a.png";